import { createSelector } from 'reselect';

import { getBorrowerFullName, getPersonInitials } from 'utils/loanApplication';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLoanSummary = createSelector(selectLoanApplication, ({ loanSummary }) => loanSummary);

export const selectLoanSummaryInfo = createSelector(selectLoanSummary, ({ summary = {} }) => {
  const {
    subjectPropertyAddress,
    lockExpiration: lockExpirationDate,
    rate: interestRate,
    loanProgram: programName,
    primaryBorrowerFullName,
    primaryBorrowerName: obsoletePrimaryBorrowerName,
    ...restSummaryFields
  } = summary;

  const primaryBorrowerName = getBorrowerFullName(primaryBorrowerFullName);

  return {
    lockExpirationDate,
    subjectPropertyAddress,
    interestRate,
    programName,
    primaryBorrowerName,
    initials: getPersonInitials(primaryBorrowerFullName),
    ...restSummaryFields,
  };
});
